import React from "react";
import { useLocation } from "react-router-dom";
import { useAppTranslation } from "@/utils/useAppTranslation";
import { LocationStateSearch } from "./types";
import FormWrapper from "./forms";

const Create: React.FC = () => {
  const location = useLocation();
  const locationSearch = (location.state as LocationStateSearch)?.locationSearch;
  const { t } = useAppTranslation();

  return <FormWrapper title={t("product.add.title")} locationSearch={locationSearch} />;
};

export default Create;
